import { HomeFilled, Login } from "@mui/icons-material";
import {
  Container,
  Card,
  CardContent,
  
  Button,
  Alert,
  
  Box,
  
  Grid,
  
} from "@mui/material";
import { Stack } from "@mui/system";
import { useNavigate } from "react-router-dom";
let logo2 = require("../../Assets/Images/logoDEC.png");

export default function RegisternConfirmation() {
  const navigate = useNavigate();
  return (

    <Container
          maxWidth="lg"
          sx={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Grid container spacing={1} alignItems="center">
            <Grid size={{ xs: 12, md: 12, lg: 12 }}>
              <Card
                elevation={3}
                sx={{
                  borderRadius: 4,
                  border: "1px solid #ddd",
                  p: 1,
                }}
              >
                  <Box
              sx={{
                textAlign: "center",
                mb: 2,
                borderBottom: "2px solid rgba(81, 35, 132, 1)",
              }}
            >
              <Box
                component="img"
                src={logo2}
                alt="Logo"
                sx={{
                  maxHeight: 40,
                  display: "inline-block",
                  pb: 0.5, // small space between image and underline
                }}
              />
            </Box>
            
                <CardContent sx={{ p: 1 }}>
                  
                  
                    <Alert severity="success">
                      Thank you for registering. Your request has been received and is currently awaiting administrator approval. You will receive a confirmation email once your account is active. 
                    </Alert>
                    <Stack sx={{mt:3}} direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center">
                <Button
                  variant="contained"
                  startIcon={<Login />}
                  onClick={() => navigate("/login")}
                  sx={{
                    bgcolor: "rgba(81, 35, 132, 1)",
                    "&:hover": { bgcolor: "rgba(61, 25, 112, 1)" },
                    borderRadius: 2,
                    px: 4
                  }}
                >
                  Go to Login
                </Button>

                <Button
                  variant="outlined"
                  startIcon={<HomeFilled />}
                  onClick={() => navigate("/")}
                  sx={{
                    color: "rgba(81, 35, 132, 1)",
                    borderColor: "rgba(81, 35, 132, 1)",
                    "&:hover": { borderColor: "rgba(61, 25, 112, 1)" },
                    borderRadius: 2,
                    px: 4
                  }}
                >
                  Back Home
                </Button>
              </Stack>
                  
                </CardContent>

              </Card>
            </Grid>
            <Grid size={{ xs: false, md: 3, lg: 2 }} />
          </Grid>
          
        </Container>
  )
}
